import styled from 'styled-components'

export const MainWrapper = styled.div`
  padding: 12px;
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: flex-start;
`

export const ModalHead = styled.div`
  padding: 28px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-content: center;
`

export const ModalFooter = styled.div`
  margin-top: auto;
  padding: 0px 24px 24px 24px;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: center;
  align-content: center;
`

export const LevelRowContainer = styled.div.attrs({
  className: `row col-12 mx-0`
})`
  border-top: ${({ borderNone, theme }) => borderNone ? 'none' : `1px solid ${theme.mocaLtGrey}`};
  padding: ${({ padding }) => padding ? padding : '24px 12px'};
`